module.exports = __webpack_public_path__ + "static/img/Supreme Master First Class.6ef36b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Supreme Master First Class.png
// module id = zvn8
// module chunks = 35